import React from 'react';
import classNames from 'classnames';
import styles from '../../assets/student-main-tab.module.scss';
import InfoItem from 'src/components/InfoItem';
import RenderFile from 'src/components/RenderFile';
import { IStudent } from 'src/types/student';

export interface StateProps {
    files: any;
}
export interface DispatchProps {}

export interface OwnProps {
    student: Partial<IStudent> | null;
    tab?: string;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}
const StudentInfo: React.FunctionComponent<Props> = ({ files, student }: Props) => {
    if (!student) {
        return null;
    }
    const {
        orderDoc,
        orderDocName,
        orderDocMimeType,
        consentDocMimeType,
        consentDoc,
        consentDocName,
        parentConsentDocMimeType,
        parentConsentDoc,
        parentConsentDocName,
    } = student;

    const orderDocFiles = [];
    if (orderDoc) {
        const orderDocFile = {
            attach: orderDoc,
            mimeType: orderDocMimeType,
            name: orderDocName,
        };
        orderDocFiles.push(orderDocFile);
    }
    const consentDocFiles = [];
    if (consentDoc) {
        const consentDocFile = {
            attach: consentDoc,
            mimeType: consentDocMimeType,
            name: consentDocName,
        };
        consentDocFiles.push(consentDocFile);
    }

    const parentConsentDocFiles = [];
    if (parentConsentDoc) {
        const authConsentDocFile = {
            attach: parentConsentDoc,
            mimeType: parentConsentDocMimeType,
            name: parentConsentDocName,
        };
        parentConsentDocFiles.push(authConsentDocFile);
    }

    const previewFiles = (data: any) =>
        data &&
        data.map((file: any, i: number) => (
            <li style={{ listStyleType: 'none' }} key={file.attach}>
                <a rel="noopener noreferrer" target="_blank" href={`${file.attach}`}>
                    <RenderFile file={file} />
                </a>
            </li>
        ));

    return (
        <div className={classNames(styles.infoWrap)}>
            <div className={classNames(styles.infoItems)}>
                <InfoItem title={'The Order:'} value={previewFiles(orderDocFiles)} />
                <InfoItem title={'Parent consent for telehealth services:'} value={previewFiles(consentDocFiles)} />
                <InfoItem
                    title={'Parent consent for authorization change:'}
                    value={previewFiles(parentConsentDocFiles)}
                />
                <InfoItem title={'Other Supporting Documents:'} value={previewFiles(files)} />
            </div>
        </div>
    );
};

export default StudentInfo;
